export default __webpack_public_path__ + "static/media/login-bg.4f2f2d49.svg";